import { useRef, useMemo } from "react"
import { useInView, useScroll, useReducedMotion } from "framer-motion"
import { isMobileOnly } from "react-device-detect"

import { useConsole } from "contexts/Console"
import { useEnv } from "contexts/Env"

import { media } from "css/breakpoints"

import generateModularBlocks from "utils/generateModularBlocks"

import { slideUp } from "animations/slideUp"

import { Root, Edito, Media, FCaption } from "./style"
import Sequence from "./Sequence"

import Image from "components/media/ImageCLD"

import FigCaption from "components/figcaption/FigCaption"

export default function FocusFeatures({
  className,
  texts,
  number_images,
  image_portrait_cld: image_portrait,
  image_portrait_width,
  image_portrait_height,
  image_landscape_cld: image_landscape,
  image_landscape_width,
  image_landscape_height,
  order_mobile,
  order_desktop,
  fig_caption,
}) {
  const console = useConsole()
  const env = useEnv()
  const prefersReducedMotion = process.browser && document.documentElement.classList.contains("prefers-reduced-motion")

  const modularBlocks = useMemo(() => generateModularBlocks(texts, { console }), [])

  const rootRef = useRef()
  const mediaRef = useRef()
  const editoRef = useRef()

  const isEditoInView = useInView(editoRef, { margin: "100% 0% 0% 0%" })

  const { scrollYProgress } = useScroll({ target: mediaRef, offset: ["start end", "end end"] })

  let imagePortrait = image_portrait
  let imageLandscape = image_landscape

  if (prefersReducedMotion) {
    imagePortrait = image_portrait.replace("0000", (number_images - 1).toString().padStart(4, "0"))
    imageLandscape = image_landscape.replace("0000", (number_images - 1).toString().padStart(4, "0"))
  }

  const image = {
    sources: [
      {
        media: media.portrait,
        src: `https://${env.cloudinary.secureDistribution}/image/upload/t_v7/v1${imagePortrait}`,
        width: image_portrait_width,
        height: image_portrait_height,
      },
      {
        media: media.landscape,
        src: `https://${env.cloudinary.secureDistribution}/image/upload/t_v7/v1${imageLandscape}`,
        width: image_landscape_width,
        height: image_landscape_height,
      },
    ],
  }

  return (
    <Root className={className} ref={rootRef}>
      <Edito ref={editoRef} variants={slideUp} initial='hidden' animate={isEditoInView ? "show" : "hide"} order={isMobileOnly ? order_mobile : order_desktop}>
        {modularBlocks}
      </Edito>

      <Media ref={mediaRef} order={isMobileOnly ? order_mobile : order_desktop}>
        {prefersReducedMotion ? (
          <Image {...image} />
        ) : (
          <Sequence image={image} anim_range_start={0} anim_range_end={number_images - 1} prog={scrollYProgress} />
        )}

        {fig_caption?.caption?.length ? (
          <FCaption>
            <FigCaption {...fig_caption} />
          </FCaption>
        ) : null}
      </Media>
    </Root>
  )
}
